app.mediator.registerModule(MODULE_NAME__STICKY_FOLLOWER_TOP, function (app) {

    var $buttonElem = null;
    var $labelElem = null;
    var buttonText = null;
    var labelText = null;

    return {

        $rootElem: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },

        init: function () {

            var helpers = app.helpers.funcs;

            // Init
            var scope = this;
            scope.$rootElem = $('.mod-sticky-follower-top,.news-letter-container');
            if (!scope.$rootElem.length) return;

            this.logOriginalOffset();

            $buttonElem = scope.$rootElem.find('li:last-child .btn-inner');
            buttonText = $buttonElem.text();

            $labelElem = scope.$rootElem.find('li:first-child .btn-inner');
            labelText = $labelElem.text();

            // DOM event listeners
            app.globalEventRegistry.addListener('resize', function () {
                scope.logOriginalOffset();
                scope.conditionallyStick();
                scope.conditionallySwitchButtonText();
            });

            // There is a bug in safari whereby things with fixed positions jitter about
            // on scroll. We can mitigate this by more aggressively gating the amount of
            // times that we respond to a scroll event firing when in safari.
            function respondToScroll() {
                scope.logOriginalOffset();
                scope.conditionallyStick();
            }
            if (helpers.isSafari()) {
                $(window).on('scroll touchmove', helpers.throttler(function (e) {
                    respondToScroll();
                }, 500));
                $(window).on('mousewheel', helpers.throttler(function (e) {
                    respondToScroll();
                }, 25));
            } else {
                $(window).on('scroll touchmove', helpers.throttler(function (e) {
                    respondToScroll();
                }, 25));
            }

            scope.$rootElem.each(function (k, v) {
                var $elem = $(v);
                if ($elem.length && $elem.hasClass('mod-sticky-follower-top')) {
                    app.mediator.notify(EVENT_NAME__STICKY_FOLLOWER_TOP__WITH_STICKY_INITIATED);
                }
            });
            scope.conditionallySwitchButtonText();
        },

        deinit: function () {
            app.globalEventRegistry.removeListener('stickEnterCta');
        },

        //==========================================================xdiv2====
        // Mediator event handlers
        //===================================================================

        // None yet

        //==========================================================xdiv2====
        // Module
        //===================================================================

        topOffset: null,

        logOriginalOffset: function () {
            this.$rootElem.removeClass('navbar-fixed-top');
            this.topOffset = this.$rootElem.offset().top;
        },

        conditionallyStick: function () {
            var scope = this;
			var screenTop = $(window).scrollTop();
			if (screenTop > this.topOffset) {
                this.$rootElem.each(function () {
			        if ($(this).hasClass('mod-sticky-follower-top')) {

                        // By creating space in the box model that is the same height as the element that we just removed from the box model,
                        // (by making it static), the rest of the page content doesn't "jump up".
                        var height = scope.$rootElem.height();
                        var $elem = $(this);
                        $('.mod-sticky-follower-top-placeholder').css({height: height});
                        if (!$elem.hasClass('navbar-fixed-top')) {
                            $elem.addClass('navbar-fixed-top');
                        }
			        }
			    });
			} else {
			    this.$rootElem.each(function () {
			        if ($(this).hasClass('mod-sticky-follower-top')) {
                        var $elem = $(this);
                        if (scope.$rootElem) {
                            $('.mod-sticky-follower-top-placeholder').css({height: ''});
                            if ($elem.hasClass('navbar-fixed-top')) {
                                $elem.removeClass('navbar-fixed-top');
                            }
                        }
			        }
			    });
			}
        },

        conditionallySwitchButtonText: function() {
            var scope = this;
            var screenSize = app.helpers.funcs.getScreenSize();
            if (screenSize == app.helpers.screenBreakpoints.xs) {
                scope.useLongTextForButton();
            } else {
                scope.useShortTextForButton();
            }
        },

        useShortTextForButton: function () {
            $buttonElem.text(buttonText);
        },

        useLongTextForButton: function () {
            $buttonElem.text(labelText);
        }
	};
});